var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 0.212891V7.21289V32.2129H0V7.21289L7 0.212891H32Z",
    fill: "url(#paint0_linear_4244_147913)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9538 8.21289C14.1985 8.21479 12.5156 8.91292 11.2745 10.1541C10.0333 11.3953 9.33515 13.0781 9.33325 14.8334C9.33325 18.3898 15.3293 23.8401 15.5841 24.0707C15.6855 24.1622 15.8172 24.2129 15.9538 24.2129C16.0904 24.2129 16.2221 24.1622 16.3234 24.0707C16.5783 23.8401 22.5743 18.3898 22.5743 14.8334C22.5724 13.0781 21.8743 11.3953 20.6331 10.1541C19.3919 8.91292 17.7091 8.21479 15.9538 8.21289V8.21289ZM15.9538 17.0403C15.5173 17.0403 15.0907 16.9109 14.7277 16.6684C14.3648 16.4259 14.082 16.0812 13.9149 15.678C13.7479 15.2747 13.7042 14.831 13.7894 14.4029C13.8745 13.9748 14.0847 13.5816 14.3933 13.273C14.702 12.9643 15.0952 12.7541 15.5233 12.669C15.9513 12.5838 16.3951 12.6275 16.7983 12.7946C17.2016 12.9616 17.5462 13.2445 17.7887 13.6074C18.0312 13.9703 18.1606 14.397 18.1606 14.8334C18.1606 15.4187 17.9281 15.98 17.5143 16.3939C17.1004 16.8078 16.5391 17.0403 15.9538 17.0403Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4244_147913",
    x1: -1.58138e-9,
    y1: 16.2129,
    x2: 31.9457,
    y2: 16.1924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F51919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#770001"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d0545234002c53778953f2b9d99b557b.svg";
export { ForwardRef as ReactComponent };